import { render, staticRenderFns } from "./Discovery.vue?vue&type=template&id=2b96cdf7&scoped=true&"
import script from "./Discovery.vue?vue&type=script&lang=ts&"
export * from "./Discovery.vue?vue&type=script&lang=ts&"
import style0 from "./Discovery.vue?vue&type=style&index=0&id=2b96cdf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b96cdf7",
  null
  
)

export default component.exports